const getDefaultErrorMessage = siteId =>
  siteId === 'MLB' ? '¡Ops! Ocorreu um erro. Por favor, tente novamente.' : '¡Ups! hubo un error. Inténtalo más tarde.';

export { getDefaultErrorMessage };
